import { Padder, SideModal, Text } from '@oy/uidesktop';
import { CardComponent } from './CardComponent';
import { ShortcutSideModalProps } from './constant';
import { useShortcutSideModalImpl } from './useShortcutSideModalImpl';

export const ShortcutSideModal = ({
  show,
  showVendorMaintenance,
  productName,
  onClose,
  handleToggleSideModal,
  handleAutoReportModal,
  handleFaqModal,
}: ShortcutSideModalProps) => {
  const { shortcutMenu, shortcutTitle } = useShortcutSideModalImpl({
    showVendorMaintenance,
    productName,
    handleToggleSideModal,
    handleAutoReportModal,
    handleFaqModal,
  });

  return (
    <SideModal show={show} onClose={onClose}>
      <SideModal.Header showDivider>
        <Text textStyle={Text.Style.BodyLgSemibold}>
          {shortcutTitle(productName)}
        </Text>
      </SideModal.Header>
      <SideModal.Body>
        <Padder
          all={Padder.Size.XL}
          style={{
            gap: '16px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {shortcutMenu.map((menu, index) => {
            if (
              menu.showVisibility.includes(productName) &&
              menu.havePermission
            ) {
              return (
                <CardComponent key={`${menu.title}-${index}`} menu={menu} />
              );
            }
          })}
        </Padder>
      </SideModal.Body>
    </SideModal>
  );
};
